export default function HowCanIGetIt({
  onOpenSidebar,
}: {
  onOpenSidebar: (view: string) => void
}) {
  return (
    <div className="p-4 mb-6 shadow-fulfilment">
      <div className="text-label font-bold text-text-subdued pb-4">
        HOW CAN I GET IT?
      </div>
      <div className="text-label text-text-subdued pb-2">
        Product unavailable? Please&nbsp;
        <span
          className="underline hover:cursor-pointer"
          onClick={() => onOpenSidebar('SERVICE_PORTAL_VIEW')}
        >
          enquire
        </span>
        &nbsp;to find out about how you get this item.
      </div>
    </div>
  )
}
